import React, { useState } from "react";

const CommonDataDialog = ({
  open,
  onClose,
  title = "Available Data",
  columns = [],
  rows = [],
  rowsPerPage = 5,
}) => {
  const [page, setPage] = useState(1);

  if (!open) return null;

  const totalPages = Math.ceil(rows.length / rowsPerPage);
  const paginatedRows = rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  const nextPage = () => page < totalPages && setPage(page + 1);
  const prevPage = () => page > 1 && setPage(page - 1);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-white w-full sm:w-3/4 lg:w-1/2 max-h-[90vh] overflow-auto rounded-xl shadow-lg relative">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-6 py-4 bg-gray-100 rounded-t-xl">
          <h2 className="text-xl font-bold text-gray-800 w-full text-center">{title}</h2>
          <button
            className="absolute right-6 top-4 text-gray-600 hover:text-red-600"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {/* Table Section */}
        <div className="p-4 overflow-auto">
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 text-sm text-left">
              <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
                <tr>
                  {columns.map((col) => (
                    <th key={col.key} className="px-4 py-2 border-b">
                      {col.header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedRows.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} className="text-center py-6 text-gray-500">
                      No data available
                    </td>
                  </tr>
                ) : (
                  paginatedRows.map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      {columns.map((col) => (
                        <td key={col.key} className="px-4 py-2 border-b">
                          {row[col.key]}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-between items-center mt-4 text-sm text-gray-700">
              <button
                onClick={prevPage}
                disabled={page === 1}
                className="px-3 py-1 bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"
              >
                Prev
              </button>
              <span>
                Page {page} of {totalPages}
              </span>
              <button
                onClick={nextPage}
                disabled={page === totalPages}
                className="px-3 py-1 bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonDataDialog;
